import React from 'react'
import { Select, Space } from 'antd';
import styled from 'styled-components';

function SelectItem(props) {
    return (
        <SpaceItem wrap gap={props.gap} mr={props.mr} mb={props.mb} ml={props.ml} $fill={props.width === "100%"}>
            {props.is_icon ? <SelectIcon gap={props.gap}>₹</SelectIcon> : null}
            <ItemSelect
                is_icon={props.is_icon}
                size={props.size ? props.size : "large"}
                placeholder={props.placeholder ? props.placeholder : "Select"}
                disabled={props.disabled}
                style={{ width: props.width ? props.width : 230 }}
                popupMatchSelectWidth={false}
                dropdownStyle={{
                    minWidth: 200,
                    borderRadius: 10,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    padding: "4px",
                }}
                listHeight={220}
                onChange={(value) => {
                    if (props?.setFieldValue != undefined) {
                        props.setFieldValue(props.name, value);
                    } else {
                        props.handleChange();
                    }
                }}
                options={props.options}
                value={props.value}
                bradius={props.bradius}
                popupClassName="custom-select-dropdown"
            />
        </SpaceItem>
    );
}

export default SelectItem;

const SpaceItem = styled(Space)`
    position: relative;
    width: ${({ $fill }) => $fill ? '100%' : 'auto'};
    gap: ${({ gap }) => gap ? gap : '8px'};
    margin-right: ${({ mr }) => mr ? mr : "unset"};
    margin-left: ${({ ml }) => ml ? ml : "unset"};
    margin-bottom: ${({ mb }) => mb ? mb : "unset"};

    /* Make the inner Space item wrapper stretch */
    ${({ $fill }) => $fill ? `
        & .ant-space-item {
            width: 100%;
        }
    ` : ''}
`;

const SelectIcon = styled.span`
    z-index: 9;
    position: absolute;
    top: 10px;
    left: ${({ gap }) => gap ? "9px !important" : '17px'};
    color: #242424 !important;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Roboto';
    font-style: normal;
`;

const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: ${({ bradius }) => bradius ? bradius : "8px !important"};
        padding-left: ${({ is_icon }) => is_icon ? "20px !important" : 'unset'};
        min-height: 34px !important;
        font-size: 13px !important;
        transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
    }
    & .ant-select-selection-placeholder {
        color: #bbb !important;
        font-size: 13px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #bbb !important;
    }
    & .ant-select-selection-item {
        font-size: 13px !important;
        font-weight: 500;
        color: #333 !important;
    }
`;
